import { FEATURES } from './features';
import { LINK_META_CATEGORY } from './linkWidget';

const ContentTypes = {
  EVERYTHING: 'all',
  NATIVE: 'native',
  SOCIALS: 'socials',
  ARTICLE: 'article',
  RECIPE: 'recipe',
  LIST: 'list',
  IMAGE: 'image',
  PODCAST: 'podcast',
  VIDEO: 'video',
  FILE: 'file',
  EXTRAS: 'extras',
  COURSE: 'course',
  COURSE_MODULE: 'module',
  ONE_OFF_EVENT: 'one-off_event',
  FOR_SUBSCRIBERS_ONLY: 'for_subscribers_only', // actually, not a type
};

const contentIcons = {
  [ContentTypes.ARTICLE]: require('@/assets/icons/optimized/dashboard/linksTab/article.svg'),
  [ContentTypes.RECIPE]: require('@/assets/icons/optimized/dashboard/linksTab/recipe.svg'),
  [ContentTypes.LIST]: require('@/assets/icons/optimized/dashboard/linksTab/list.svg'),
  [ContentTypes.PODCAST]: require('@/assets/icons/optimized/dashboard/linksTab/podcast.svg'),
  [ContentTypes.VIDEO]: require('@/assets/icons/optimized/dashboard/linksTab/video.svg'),
  [ContentTypes.FILE]: require('@/assets/icons/optimized/dashboard/linksTab/file-upload.svg'),
  [ContentTypes.EXTRAS]: require('@/assets/icons/optimized/dashboard/linksTab/digital-item.svg'),
  [ContentTypes.COURSE]: require('@/assets/icons/optimized/dashboard/linksTab/course.svg'),
  [ContentTypes.ONE_OFF_EVENT]: require('@/assets/icons/optimized/dashboard/linksTab/event.svg'),
};

const contentEditors = {
  [ContentTypes.ARTICLE]: { name: 'ArticleEditor' },
  [ContentTypes.RECIPE]: { name: 'RecipeEditor' },
  [ContentTypes.LIST]: { name: 'ListEditor' },
  [ContentTypes.PODCAST]: { name: 'PodcastEditor' },
  [ContentTypes.VIDEO]: { name: 'VideoEditor' },
  [ContentTypes.FILE]: { name: 'FileUploadEditor' },
  [ContentTypes.EXTRAS]: { name: 'DigitalItemEditor' },
  [ContentTypes.COURSE]: { name: 'CourseEditor' },
  [ContentTypes.ONE_OFF_EVENT]: { name: 'OneOffEventEditor' },
};

const LessonCategories = {
  ON_DEMAND_VIDEO: 1,
  EXTRA_RESOURCES: 2,
  TASK: 3,
  LIVE_WORKSHOP: 4,
};

const LessonCategoryNames = {
  [LessonCategories.ON_DEMAND_VIDEO]: 'On-demand video',
  [LessonCategories.EXTRA_RESOURCES]: 'Extra resources',
  [LessonCategories.TASK]: 'Task',
  [LessonCategories.LIVE_WORKSHOP]: 'Live workshop',
};

const CONTENT_META = {
  [`${ContentTypes.EXTRAS}-`]: {
    title: 'Digital item',
    description: 'Sell access to any digital content, video or more',
    featureName: FEATURES.DIGITAL_ITEM_TEMPLATE,
    displayIcon: contentIcons[ContentTypes.EXTRAS],
    icon: {
      [LINK_META_CATEGORY.DEFAULT]: require('@/assets/icons/optimized/dashboard/addSomethingPopup/growMonetise/digital.svg'),
      [LINK_META_CATEGORY.RECOMMEND]: require('@/assets/icons/optimized/dashboard/addSomethingPopup/recommendations/digital-item.svg'),
    },
  },
  [`${ContentTypes.ARTICLE}-`]: {
    title: 'Article',
    description: 'Create a blog, article or long-form written content',
    featureName: FEATURES.ARTICLE_TEMPLATE,
    displayIcon: contentIcons[ContentTypes.ARTICLE],
    icon: require('@/assets/icons/optimized/dashboard/addSomethingPopup/createShare/article.svg'),
  },
  [`${ContentTypes.RECIPE}-`]: {
    title: 'Step-by-step guide',
    description: 'Create an instructional guide or recipe',
    featureName: FEATURES.LIST_TEMPLATES,
    displayIcon: contentIcons[ContentTypes.RECIPE],
    icon: require('@/assets/icons/optimized/dashboard/addSomethingPopup/createShare/step.svg'),
  },
  [`${ContentTypes.FILE}-`]: {
    title: 'File upload',
    description: 'Share access to digital files',
    featureName: FEATURES.FILE_UPLOAD,
    displayIcon: contentIcons[ContentTypes.FILE],
    icon: require('@/assets/icons/optimized/dashboard/addSomethingPopup/createShare/upload.svg'),
  },
  [`${ContentTypes.LIST}-`]: {
    title: 'List article',
    description: 'Share a listicle of curated items',
    featureName: FEATURES.LIST_TEMPLATES,
    displayIcon: contentIcons[ContentTypes.LIST],
    icon: require('@/assets/icons/optimized/dashboard/addSomethingPopup/createShare/article.svg'),
  },
  [`${ContentTypes.PODCAST}-`]: {
    title: 'Audio file',
    description: 'Upload a music track or podcast episode',
    featureName: FEATURES.PODCAST_AND_AUDIO_TEMPLATES,
    displayIcon: contentIcons[ContentTypes.PODCAST],
    icon: require('@/assets/icons/optimized/dashboard/addSomethingPopup/createShare/podcast.svg'),
  },
  [`${ContentTypes.VIDEO}-`]: {
    title: 'Video file',
    description: 'Upload a video',
    featureName: FEATURES.VIDEO_TEMPLATE,
    displayIcon: contentIcons[ContentTypes.VIDEO],
    icon: require('@/assets/icons/optimized/dashboard/addSomethingPopup/createShare/video.svg'),
  },
  [`${ContentTypes.COURSE}-`]: {
    title: 'Course Builder',
    description: 'Create and sell an online course',
    featureName: FEATURES.COURSE_BUILDER,
    displayIcon: contentIcons[ContentTypes.COURSE],
    icon: require('@/assets/icons/optimized/dashboard/addSomethingPopup/createShare/course.svg'),
  },
  [`${ContentTypes.ONE_OFF_EVENT}-`]: {
    title: 'Digital event',
    description: 'Create and sell access to digital event',
    featureName: FEATURES.DIGITAL_EVENT_TEMPLATE,
    displayIcon: contentIcons[ContentTypes.ONE_OFF_EVENT],
    icon: require('@/assets/icons/optimized/dashboard/addSomethingPopup/createShare/event.svg'),
  },
  [`${ContentTypes.COURSE_MODULE}-`]: {
    title: 'Course module',
    description: '',
    featureName: FEATURES.COURSE_BUILDER,
    displayIcon: contentIcons[ContentTypes.COURSE],
    icon: require('@/assets/icons/optimized/dashboard/addSomethingPopup/createShare/course.svg'),
  },
};

export {
  CONTENT_META,
  ContentTypes,
  contentIcons,
  contentEditors,
  LessonCategories,
  LessonCategoryNames,
};
